import { GhostPost, GhostTag } from 'types/ghost'

const postHasPrimaryTag = (post: GhostPost, tag: GhostTag) =>
  post.primary_tag && post.primary_tag.id === tag.id

export default postHasPrimaryTag
